/**
 * Gemini Live monolingual encounter scribe: system instruction + tool (ChartMind recording).
 */

import { Type } from '@google/genai';

export const LOG_ENCOUNTER_UTTERANCE_TOOL_NAME = 'log_encounter_utterance';

export const buildLogEncounterUtteranceToolDeclaration = () => ({
  name: LOG_ENCOUNTER_UTTERANCE_TOOL_NAME,
  description:
    'After each distinct spoken phrase or sentence you process from the encounter audio, log concise clinical text ' +
    'for the chart. Do not invent symptoms, medications, or exam findings. If unclear, log best-effort wording and mark uncertainty briefly.',
  parameters: {
    type: Type.OBJECT,
    properties: {
      textForChart: {
        type: Type.STRING,
        description: 'Faithful, concise line in the encounter language for the running encounter note (not a full SOAP).',
      },
    },
    required: ['textForChart'],
  },
});

/**
 * @param {Object} opts
 * @param {string} opts.language - BCP-47 (e.g. en-US)
 */
export const buildEncounterScribeSystemInstruction = ({ language = 'en-US' }) =>
  'You are a clinical documentation assistant listening to a live patient encounter. ' +
  'Your job is to produce accurate, concise lines for the medical record as speech occurs. ' +
  'Do not diagnose or fabricate data. ' +
  `Write logged lines in the same language as the encounter (locale hint: ${language}). ` +
  'After each meaningful utterance or short pause, call ' +
  LOG_ENCOUNTER_UTTERANCE_TOOL_NAME +
  ' with textForChart. ' +
  'Prefer one tool call per clear speaker turn; merge fragments of the same turn. ';
